import {capitalize} from 'lodash';

export const camelCaseToCapitalisedString = (text: string) =>
  capitalize(text.replace(/([a-z0-9])([A-Z])/g, '$1 $2'));
